import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { MatMenuTrigger } from '@angular/material/menu'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Params } from '@angular/router'
import { AlertService } from '@app/alert/service/alert.service'
import { ModalService } from '@app/modal/modal.service'
import { TipoComissaoDomainModel, VinculoInstituicaoModel } from '@shared/models/backend'
import { CnpjPipe } from '@widgets/pipes/cnpj/cnpj.pipe'
import { CpfPipe } from '@widgets/pipes/cpf/cpf.pipe'
import { merge } from 'rxjs'
import { map, startWith, switchMap } from 'rxjs/operators'
import { VinculoInstituicaoService } from '../vinculo-instituicao-service'

@Component({
  selector: 'app-vinculo-instituicao-table',
  templateUrl: './vinculo-instituicao-table.component.html',
  styleUrls: ['./vinculo-instituicao-table.component.scss'],
  providers: [CpfPipe, CnpjPipe],
})
export class VinculoInstituicaoTableComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger

  filterChange: EventEmitter<string> = new EventEmitter()
  dataSource = new MatTableDataSource()
  displayedColumns = []
  resultsLength = 0
  isLoadingResults = false

  private currentFilter: Params

  constructor(
    private activeRoute: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private modalService: ModalService,
    private alertService: AlertService,
    private vinculoInstituicaoService: VinculoInstituicaoService,
    private cpfPipe: CpfPipe,
    private cnpjPipe: CnpjPipe
  ) {}

  ngOnInit(): void {
    this.activeRoute.queryParams.subscribe((queryParams) => {
      this.currentFilter = queryParams
      this.filterChange.emit()
    })

    this.displayedColumns = ['cnpj', 'razaoSocial', 'tipoComissao', 'cpf', 'nomeCoordenador', 'actions']
  }

  ngAfterViewInit() {
    this.filterChange.subscribe(() => (this.paginator.pageIndex = 0))

    merge(this.paginator.page, this.filterChange)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true
          this.changeDetector.detectChanges()
          return this.vinculoInstituicaoService
            .loadVinculoInstituicaoList(this.currentFilter, this.paginator.pageIndex, this.paginator.pageSize)
            .pipe()
        }),
        map((data) => {
          this.isLoadingResults = false
          this.resultsLength = data.totalElements
          return data
        })
      )
      .subscribe((data) => {
        this.dataSource.data = data.content
        this.changeDetector.markForCheck()
      })
  }

  getTipoComissao(comissaoTipo: TipoComissaoDomainModel) {
    return comissaoTipo?.sigla
  }

  confirmarDesvinculacaoCoordenador(vinculoInstituicao: VinculoInstituicaoModel): void {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.data = {
      title: 'Deseja remover o acesso do(a) coordenador(a) da comissão?',
      message: `Após confirmar, o coordenador de CPF ${this.cpfPipe.transform(vinculoInstituicao?.coordenadorCpf)}
         não terá mais acesso ao sistema como coordenador ${vinculoInstituicao?.comissaoTipo?.sigla} da instituição
         ${vinculoInstituicao?.instituicao?.razaoSocial} do CNPJ
         ${this.cnpjPipe.transform(vinculoInstituicao?.instituicao?.cnpj)}
         e a comissão ficará sem coordenador.`,
      primaryOption: 'REMOVER',
      secondaryOption: 'CANCELAR',
      primaryOptionColor: 'warn',
    }

    dialogConfig.width = '26em'

    const modalRefComponent = this.modalService.openConfirmModal(dialogConfig)
    modalRefComponent.afterClosed().subscribe((hasConfirmed: boolean) => {
      if (hasConfirmed) {
        this.vinculoInstituicaoService.removerVinculoInstituicao(vinculoInstituicao?.vinculoInstituicaoId).subscribe(
          (_) => {
            this.alertService.showSuccess('Coordenador de comissão removido com sucesso')
          },
          (_) => {
            this.alertService.showError('Houve um erro ao desvincular o coordenador da instituição')
          },
          () => {
            this.filterChange.emit()
          }
        )
      }
    })
  }
}
